import React, { useEffect, useState } from 'react';
import { Button, Form, Image } from 'react-bootstrap';
import { FaBan, FaCheck, FaCheckCircle, FaCity, FaKey, FaRegEnvelope, FaTrashAlt, FaUser, FaWrench } from 'react-icons/fa';
import tribu from './assets/images/logo_tribu.png'; // Importez le chemin de votre image


const TribuManage = ({ annee, adherentSelect, tribus, onDataReload }) => {

    const [adherentSel, setAdherentSel] = useState({});

    const url = localStorage.getItem('url');
    const code = localStorage.getItem('code');

    const reloadDataAfterDelay = async () => {
        try {
            const response = await fetch(`${url}gettribufromtribu`);
            await response.json();
        } catch (error) {
            console.error('Erreur lors du rechargement:', error);
        }
    };

    const [newIdentifiant, setNewIdentifiant] = useState('');

    const verifIdentifiant = (identifiant) => {
        return tribus.filter(item => item.login === identifiant).length > 0;
    }

    const [newIdentifiantExist, setNewIdentifiantExist] = useState(false);

    const handleNewIdentifiant = (e) => {
        setNewIdentifiant(e.target.value);
        setNewIdentifiantExist(verifIdentifiant(e.target.value));
    }

    

    useEffect(() => {
        if (adherentSelect === undefined) return;
        setAdherentSel(adherentSelect);
        setNewIdentifiant(adherentSelect.tft_login ? adherentSelect.tft_login : '');
        setNewIdentifiantExist(adherentSelect.tft_login ? verifIdentifiant(adherentSelect.tft_login) : false);
    }, [adherentSelect]);

    const urltribu = `https://webservices.k-lix.com/TribuPrd.aspx`;

    const ModifTribu = (table, id, champ, valeur) => {
        console.log('Modif :', table, id, champ, valeur);
        // return;
        let obj = { action: 'updateobj', table, ID: id, [champ]: valeur };

        //Post
        fetch(urltribu, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify(obj)
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
            })
            .catch(error => console.error('Erreur:', error));
    }

    const ModifCrm = (table, id, champ, valeur) => {
        console.log('Modif :', table, id, champ, valeur);
        // return;
        fetch(`${url}modifCrm/${table}/${id}/${champ}/${valeur}/${code}`)
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                // getAdherent().then(() => filtreAll(boutonSel, adherents));
            })
            .catch(error => console.error('Erreur:', error));
    }

    const newGarage = (NOM, ADRESSE, LOGIN, PASSWORD, VILLE, CP, TEL, MAIL, RESEAU) => {
        return { action: 'newobj', table: "t_garage", NOM, ADRESSE, LOGIN, PASSWORD, VILLE, CP, TEL, MAIL, RESEAU, ADMIN: 0, AFFICHE_MESSAGE: 1, ACCES_INTERDIT: 0, SUPPRIMER: 0 }
    }

    const validHasTribu = (id) => {
        ModifCrm('tribu', id, 'has_tribu', 1);
        ModifCrm('tribu', id, 'fin_periode', `${annee}-12-31`);
        alert('Modification effectuée');
    }

    const handleRowClickCreateNewGarageTribu = (row) => {
        console.log('Ligne cliquée :', row);
        console.log(row.nom_de_l_entreprise, row.adresse1, newIdentifiant, 'P@ssword', row.ville, row.code_postal, row.telephone, row.e_mail_2 ? row.e_mail_2 : row.e_mail_1 ? row.e_mail_1 : row.e_mail_3, row.reseau);
        let obj = newGarage(row.nom_de_l_entreprise, row.adresse1, newIdentifiant, 'P@ssword', row.ville, row.code_postal, row.telephone, row.e_mail_2 ? row.e_mail_2 : row.e_mail_1 ? row.e_mail_1 : row.e_mail_3, row.reseau);
        console.log(obj);



        if (window.confirm(`Ce compte sera créé dans tribu : ${obj.LOGIN} ${obj.PASSWORD}`)) {
            //POST
            fetch(urltribu, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(obj)
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Réponse du serveur:', data);
                    //getAdherent().then(() => filtreAll(boutonSel, adherents));
                    // console.log('Modif :', 'tribu', row.t_id, 'login', newIdentifiant);
                    ModifCrm('tribu', row.t_id, 'login', newIdentifiant);
                    // console.log('Modif :', 'tribu', row.t_id, 'has_tribu', 1);
                    ModifCrm('tribu', row.t_id, 'fin_periode', `${annee}-12-31`);
                    ModifCrm('tribu', row.t_id, 'has_tribu', 1);
                    // Lancer le rechargement des données
                    reloadDataAfterDelay();
                    alert('Modification effectuée');

                })
                .catch(error => {
                    console.error('Erreur:', error)
                    alert('Erreur lors de la création du compte dans tribu');
                    alert('Merci de contacter le support\r\n' + error);
                });
        }
    }


    //submit
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('submit');
        handleRowClickCreateNewGarageTribu(adherentSel);
    }

    const handleAccesTribu = (val) => {
        console.log('Modif :', 'tribu', adherentSel.tft_id, 'acces_interdit', val);
        ModifTribu('T_GARAGE', adherentSel.tft_id, 'acces_interdit', val);
        setAdherentSel({ ...adherentSel, tft_acces_interdit: val });
        alert('Modification effectuée');
    }


    return (
        <>
            {/* {JSON.stringify(adherentSel)}
            <hr />
        {JSON.stringify(adherentSelect)}
        <hr />
        {JSON.stringify(tribus)} */}
            <div className='row'>


                {!(adherentSel.nom_de_l_entreprise === null || adherentSel.nom_de_l_entreprise === '' ||
                    adherentSel.adresse1 === null || adherentSel.adresse1 === '' ||
                    adherentSel.code_postal === null || adherentSel.code_postal === '' ||
                    adherentSel.ville === null || adherentSel.ville === '' ||
                    ((adherentSel.e_mail_1 === null || adherentSel.e_mail_1 === '') &&
                        (adherentSel.e_mail_2 === null || adherentSel.e_mail_2 === '') &&
                        (adherentSel.e_mail_3 === null || adherentSel.e_mail_3 === ''))) &&
                    adherentSel.login === null &&
                    <div className='col-6'>
                        <h2>Créer un compte dans tribu</h2>
                        <FaUser /> {adherentSel.nom_de_l_entreprise}<br />
                        <FaCity /> {adherentSel.adresse1}<br />
                        <FaCity /> {adherentSel.code_postal} {adherentSel.ville}<br />
                        {adherentSel.e_mail_2 && (
                            <>
                                <FaRegEnvelope /> {adherentSel.e_mail_2}
                                {adherentSel.mail && adherentSel.e_mail_2 === adherentSel.mail && (
                                    <Form.Text className="text-danger"><FaBan /> Mail déjà utilisé </Form.Text>
                                )}
                                <br />
                            </>
                        )}
                        {adherentSel.e_mail_1 && !adherentSel.e_mail_2 && (
                            <><FaRegEnvelope /> {adherentSel.e_mail_1}
                                {adherentSel.mail && adherentSel.e_mail_1 === adherentSel.mail && (
                                    <Form.Text className="text-danger"><FaBan />Mail déjà utilisé</Form.Text>
                                )}
                                <br />
                            </>
                        )}
                        {!adherentSel.e_mail_1 && !adherentSel.e_mail_2 && adherentSel.e_mail_3 && (
                            <>
                                <FaRegEnvelope /> {adherentSel.e_mail_3}
                                {adherentSel.mail && adherentSel.e_mail_3 === adherentSel.mail && (
                                    <Form.Text className="text-danger"><FaBan />Mail déjà utilisé</Form.Text>)}
                                <br />
                            </>
                        )}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formBasicEmail" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <Form.Label style={{ display: 'flex', alignItems: 'center', marginBottom: '0', marginRight: '10px' }}>
                                    <Image src={tribu} style={{ width: '40px', marginRight: '5px' }} />
                                    Identifiant :
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Identifiant"
                                    value={newIdentifiant}
                                    onChange={handleNewIdentifiant}
                                    style={{ flex: '1' }}
                                />
                            </Form.Group>
                            {newIdentifiantExist && <Form.Text className="text-danger"><FaBan /> Cet identifiant existe déjà</Form.Text>}
                            {!newIdentifiantExist && <Form.Text className="text-success"><FaCheck /> Cet identifiant est disponible</Form.Text>}<br />
                            <div className="d-grid gap-2">
                                <Button variant="primary" type="submit" disabled={newIdentifiantExist || !newIdentifiant.trim()}>
                                    Créer
                                </Button>
                            </div>
                        </Form>
                    </div>
                }
                {adherentSel.login !== null &&
                    <>
                        <div className='col-12'>
                            <h2>Compte tribu</h2>
                            <FaWrench /> {adherentSel.tft_nom}<br />
                            <FaCity /> {adherentSel.tft_adresse}<br />
                            <FaCity /> {adherentSel.cp} {adherentSel.tft_ville}<br />
                            <FaRegEnvelope /> {adherentSel.tft_mail}<br />
                            <Image src={tribu} style={{ width: '40px' }} /> {adherentSel.tft_login}<br />

                        </div>
                        {/* {JSON.stringify(adherentSel)} */}
                        {(adherentSel.has_tribu_actif === 1 && adherentSel.has_tribu === 0)
                            && (<div className='col-12'>
                                <br />
                                Il y a un souci dans la base de données, l'utilisateur est abonné à tribu et has_tribu à 0
                                <div className="d-grid gap-2">
                                    <Button variant="primary" onClick={() => validHasTribu(adherentSel.t_id)}>
                                        Mettre has_tribu à 1 et fin_periode à {annee}-12-31
                                    </Button>
                                </div>
                            </div>)}
                        {(adherentSel.has_tribu_actif === 1 && adherentSel.acces_interdit === 1)
                            && (<div className='col-12'>
                                <br />
                                Il y a un souci dans la base de données, l'utilisateur est abonné à tribu et a un accès interdit dans tribu
                                <div className="d-grid gap-2">
                                    <Button variant="primary" onClick={() => ModifTribu('T_GARAGE', adherentSel.tft_id, 'acces_interdit', 0)}>
                                        Mettre acces_interdit à 0 pour {adherentSel.nom}
                                    </Button>
                                </div>
                            </div>)}
                    </>}

                {adherentSel.tft_login !== null && (<>
                    <br /><br />
                    <div className="row text-center">

                        <div className="col-4">
                            <button class="btn btn-sm text-warning" id="key"><FaKey /></button>
                        </div>
                        <div className="col-4">
                            {adherentSel.tft_acces_interdit === 0 && <button class="btn btn-sm text-success" id="access" onClick={() => handleAccesTribu(1)} title="Désactiver l'accès"
                            ><FaCheckCircle /></button>}
                            {adherentSel.tft_acces_interdit === 1 && <button class="btn btn-sm text-danger" id="ban"
                                onClick={() => handleAccesTribu(0)} title="Activer l'accès"
                            ><FaBan /></button>}
                        </div>
                        <div className="col-4">
                            {adherentSel.tft_acces_interdit === 1 && <button class="btn btn-sm text-danger" id="delete" title="Supprimer"><FaTrashAlt /></button>}
                            {/* {adherentSel.tft_acces_interdit === 0 && <button class="btn btn-sm text-muted" id="delete" disabled><FaTrashAlt /></button>} */}
                        </div>
                    </div>
                </>)}
            </div>
        </>);
}

export default TribuManage;
